import { ADMIN_AUTH_IPS } from '@/store/actions/admin/auth_ips.actions';

const initialState = {
  auth_ips: [],
  auth_ips_meta: {}
};

export default function authIpsReducer(state = initialState, action) {
  switch (action.type) {
    case ADMIN_AUTH_IPS:
      return {
        ...state,
        auth_ips: action.payload.data || [],
        auth_ips_meta: action.payload.meta || {}
      };
    default:
      return state;
  }
}
